import { render, staticRenderFns } from "./screenDevolucionesNota.vue?vue&type=template&id=754fbdf7&scoped=true"
import script from "./screenDevolucionesNota.vue?vue&type=script&lang=js"
export * from "./screenDevolucionesNota.vue?vue&type=script&lang=js"
import style0 from "./screenDevolucionesNota.vue?vue&type=style&index=0&id=754fbdf7&prod&lang=css"
import style1 from "./screenDevolucionesNota.vue?vue&type=style&index=1&id=754fbdf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754fbdf7",
  null
  
)

export default component.exports